import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ConsentProvider } from "@/context/ConsentContext";
import CookieBanner from "@/components/CookieBanner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Archive from "@/pages/Archive";
import Article from "@/pages/Article";
import Methodology from "@/pages/Methodology";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AdminEditor from "@/pages/AdminEditor";
import NotFound from "@/pages/NotFound";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import LegalNotes from "@/pages/LegalNotes";
import Contatti from "@/pages/Contatti";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
      <AuthProvider>
        <ConsentProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/archivio" element={<Archive />} />
              <Route path="/discorso/:id" element={<Article />} />
              <Route path="/metodologia" element={<Methodology />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/note-legali" element={<LegalNotes />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/nuovo"
              element={
                <ProtectedRoute>
                  <AdminEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/modifica/:id"
              element={
                <ProtectedRoute>
                  <AdminEditor />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-center" richColors />
          <CookieBanner />
        </BrowserRouter>
        </ConsentProvider>
      </AuthProvider>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
